import cn from 'classnames';
import React from 'react';

import SteppedModal from 'components/SteppedModal';
import { FacebookPostModalProps } from './types';
import { block } from './utils';

const FacebookPostModal = React.forwardRef<
  SteppedModal,
  FacebookPostModalProps
>(
  (
    {
      title,
      show,
      steps,
      defaultStep,
      className,
      onStepChange,
      onHide,
      onExited,
    },
    ref,
  ) => {
    return (
      <SteppedModal
        baseClassName={cn(block(), className)}
        {...{
          ref,
          title,
          show,
          steps,
          defaultStep,
          onStepChange,
          onHide,
          onExited,
        }}
      />
    );
  },
);

export default FacebookPostModal;
